// extracted by mini-css-extract-plugin
module.exports = {"list":"m3pgsxD__iB4KNDNhK7BL","item":"_1Oe8ovk75rQFg4iTqlTVsT","card":"_27nQQGNTHpf6TnqJoka510","empty":"sfmvqcYdQ3l5YE-5UW7RC"};